import * as React from 'react';
import { SVGProps } from 'react';
const SchemaButtonUpload = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={18} fill="none" {...props}>
    <path
      stroke={props.color || '#344054'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.667}
      d="M6.667 12.333 10 9m0 0 3.333 3.333M10 9v7.5m6.667-3.548a4.583 4.583 0 0 0-2.917-8.12.516.516 0 0 1-.445-.25 6.25 6.25 0 1 0-9.816 7.58"
    />
  </svg>
);
export default SchemaButtonUpload;
